import React from "react";
import { Wrapper } from "@/components/Wrapper";
import { BenefitsListExtended } from "../BenefitsListExtended";
import { Typography } from "@/components/Typography";
import { PlanWrapper } from "../PlanWrapper";
import { renderPhoneBox } from "@/utils/pricing";
import { SubscriptionPlansNotLoggedProps } from "../types";

export const SubscriptionPlansNotLogged = ({
  data,
  currentPlan,
  onSelectPlan,
  isStatusActive,
}: SubscriptionPlansNotLoggedProps) => {
  return (
    <>
      <div className="subscription-plans-notlogged__container">
        <Wrapper customClass="userNotLogged">
          <PlanWrapper
            data={data}
            currentPlan={currentPlan}
            onSelectPlan={onSelectPlan}
            isStatusActive={isStatusActive}
            customClass={"plan-wrapper__userNotLogged"}
          />
        </Wrapper>
        {renderPhoneBox(data, "middle")}
        <div
          className="dynamic-benefits__userNotLogged"
          id="dynamic-benefits__userNotLogged">
          <div className="dynamic-benefits__wrapper">
            <Typography
              classname={"benefitsExtended-title"}
              Tag={"h3"}>
              {data?.benefitsExtended?.title}
            </Typography>
            <BenefitsListExtended list={data.benefitsExtended?.listExtended} />
          </div>
        </div>
      </div>
    </>
  );
};
